export default "__VITE_ASSET__CUCKjGtj__"